<app-document-subheader/>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      <div class="page-container">
        <div class="card card-light w-100">
          <div class="card-body">
            <div class="container-fluid">

              <div class="container-fluid">
                <form [formGroup]="knownIpAddressForm"
                      (ngSubmit)="onSubmit()"
                      [hasUnsavedData]="knownIpAddressForm">
                  <button type="submit" hidden="hidden"></button>

                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="form-group">
                        <label class="form-title-label" for="name" translate
                        >KNOWN_IP_ADDRESS_LBL_ADDRESS</label
                        >
                        <input
                          id="address"
                          class="form-control form-title"
                          type="text"
                          formControlName="address"
                          checkFormFieldValidity
                          [maxLength]="45"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="col"></div>
                  </div>
                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="form-group row">
                        <label class="col-4 col-form-label-sm" translate>
                          KNOWN_IP_ADDRESS_LBL_WORK_LOCATION_NAME
                        </label>
                        <div class="col">
                          <app-typeahead
                            [routeEndpoint]="'WorkLocations'"
                            [entity]="Entity.WorkLocation"
                            [controlForm]="this.knownIpAddressForm.controls['workLocationId']"
                            [orderBy]="'name asc'"
                            [limitToList]="true"
                            [domain]="'active=true'"
                            [pageSize]="50"
                          ></app-typeahead>
                        </div>
                      </div>


                    </div>
                    <div class="col">

                    </div>
                  </div>

                </form>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-comment">
      <app-comment-panel
        [entityType]="'KnownIpAddress'"
        [entityId]="this.knownIpAddressId.toString()"
      ></app-comment-panel>
    </div>
  </div>
</div>
